import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null,
  isAuthenticated: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
      state.isAuthenticated = true;
    },
    clearUser: (state) => {
      state.user = null;
      state.isAuthenticated = false;
    },
    inActiveSubscription: (state) => {
      state.user.subscription.status = 'inactive';
    },
  },
});
export const { setUser, clearUser, inActiveSubscription } = authSlice.actions;
export default authSlice.reducer;
